<template>
  <div class="share mt-m pb-xxxl wrapper bg-grey">
    <div class="share-inner pt-m">
      <!-- <button v-if="canShare" class="share__button" @click="onShare">
        {{ t('social.partager-l-article-sur') }}
        <SvgSprite
          symbol="social-facebook"
          size="24"
          role="img"
          class="icon"
          :aria-label="t('global.share-facebook')"
        />
      </button> -->

      <template v-if="url">
        <div class="share__label pt-m">
          {{ t('social.partager-l-article-sur') }}
        </div>
        <a
          :href="`https://www.facebook.com/sharer/sharer.php?u=${url}`"
          target="_blank"
          class="share__link"
        >
          <span>{{ t('social.partager-l-article-sur') }} Facebook</span>

          <SvgSprite
            symbol="social-facebook"
            size="24"
            role="img"
            class="icon"
          />
        </a>

        <a
          :href="`http://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${resource.content.title}`"
          target="_blank"
          class="share__link"
        >
          <span>{{ t('social.partager-l-article-sur') }} Linkedin</span>

          <SvgSprite
            symbol="social-linkedin"
            size="24"
            role="img"
            class="icon"
          />
        </a>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { SvgSprite } from 'vue-svg-sprite'

import { useResourceStore } from '@/stores/resource'

const { t } = useI18n()
const resource = useResourceStore()
const url = ref<string | null>(null)
// const canShare = ref(true)

// To clean if not used:
// Opens native sharing modal
// const onShare = async () => {
//   if (!url.value) {
//     return
//   }

//   const data = {
//     title: resource.content.title,
//     url: url.value,
//   }

//   try {
//     await navigator.share(data)
//   } catch (err) {
//     console.log(err)
//   }
// }

onMounted(() => {
  url.value = window.location.href

  // if (!navigator.canShare) {
  //   canShare.value = false
  // }
})
</script>

<style lang="scss" scoped>
.share {
  @extend %text-center;

  @include mq(m) {
    --wrapper-padding: 4;
  }

  @include mq(wrapper) {
    --wrapper-padding: 6;
  }
}

.share-inner {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  border-top: 0.1rem solid var(--c-accent-40);
}

.share__button {
  @extend %button-nostyle;

  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: color 0.2s;

  &:hover,
  &:focus-visible {
    color: $c-grey;
  }

  .icon {
    margin: $spacing * 0.5;
    color: currentcolor;
  }

  &::after {
    @include center-xy;

    content: '';
    width: 200%;
    height: 200%;
  }
}

.share__label {
  width: 100%;
}

.share__link {
  display: flex;
  width: fit-content;
  padding: $spacing * 0.5;
  color: var(--c-body);
  transition: color 0.2s;

  span {
    @extend %visually-hidden;
  }

  .icon {
    fill: currentcolor;
  }

  &:hover,
  &:focus-visible {
    color: $c-cobalt;
  }
}
</style>
